// extracted by mini-css-extract-plugin
export var bounce = "FormAudit-module--bounce--e44f1";
export var dotMoveLeft = "FormAudit-module--dot-move-left--23d6e";
export var dotMoveRight = "FormAudit-module--dot-move-right--b9d44";
export var error = "FormAudit-module--error--fce80";
export var failure = "FormAudit-module--failure--c648e";
export var form = "FormAudit-module--form--15f5f";
export var gradient = "FormAudit-module--gradient--547b7";
export var separatorWidth = "FormAudit-module--separator-width--46440";
export var successful = "FormAudit-module--successful--41deb";